import {
  CustomSeriesOptions,
  customSeriesDefaultOptions,
} from "lightweight-charts";

export interface EarningsseriesOptions extends CustomSeriesOptions {
  //* Define the options for the series.
  highLineColor: string;
  lowLineColor: string;
  areaColor: string;
  highLineWidth: number;
  lowLineWidth: number;
}

export const defaultOptions: EarningsseriesOptions = {
  //* Define the default values for all the series options.
  ...customSeriesDefaultOptions,
  highLineColor: "#FF0000",
  lowLineColor: "#FF0000",
  areaColor: "rgba(255, 0, 0, 0.4)",
  highLineWidth: 1,
  lowLineWidth: 1,
} as const;
